import React, { useState } from 'reactn';

import { Switch, RouteComponentProps } from 'react-router-dom';
import { Tab, Tabs, Typography, Box, useMediaQuery, Container, AppBar } from '@material-ui/core';

import { history } from 'meta/constants';
import { Page, ImageCard, CustomLink, SEO } from 'components';
import theme from 'meta/theme';
import Route from 'components/Route';
import Commands from './Commands';
import Introduction from './Introduction';

import PatreonImage from 'resources/feature/patreon.png';
import POHImage from 'resources/feature/poh.jpg';
import PVMImage from 'resources/feature/pvm.jpg';
import MHImage from 'resources/feature/mh.jpg';

import SimpleGrid from 'components/SimpleGrid';
import { Alert, AlertTitle } from '@material-ui/lab';

const tabs = [
	{
		name: 'Intro',
		link: '/oldschoolbot',
		component: Introduction,
		slug: ''
	},
	{
		name: 'Commands',
		link: '/oldschoolbot/commands',
		component: Commands,
		slug: 'commands'
	},
	{
		name: 'Minions',
		externalLink: 'https://wiki.oldschool.gg/'
	},
	{
		name: 'Rules',
		externalLink: 'https://wiki.oldschool.gg/rules'
	},
	{
		name: 'FAQ',
		externalLink: 'https://wiki.oldschool.gg/faq'
	}
];
interface TParams {
	slug: string;
}

const OldSchoolBotIndexPage: React.FC<RouteComponentProps<TParams>> = (props) => {
	const tabShown =
		tabs.find((tab) => typeof tab.slug === 'string' && tab.slug === props.match.params.slug) ||
		tabs[0];
	const tabIndex = tabs.indexOf(tabShown);

	const [selectedTab, setTab] = useState(tabIndex);

	const matches = useMediaQuery(theme.breakpoints.up('md'));

	const toolbar = (
		<Box
			display="flex"
			flexDirection={matches ? 'row' : 'column'}
			alignItems="center"
			justifyContent="space-around"
			overflow="hidden"
			maxWidth="100%"
		>
			<Typography variant="h6" component="h1">
				Old School Bot
			</Typography>
			<Box maxWidth="100%">
				<AppBar elevation={0} position="relative" color="primary">
					<Tabs
						value={selectedTab}
						onChange={(_, val) => {
							console.log({ val });
							if (tabs[val].externalLink) {
								window.open(tabs[val].externalLink);
							} else {
								history.push(tabs[val].link as string);
								setTab(val);
							}
						}}
						indicatorColor="secondary"
						textColor="secondary"
						variant="scrollable"
						scrollButtons="auto"
					>
						{tabs.map((tab, index) => (
							<Tab key={tab.name} value={index} label={tab.name} component="a" />
						))}
					</Tabs>
				</AppBar>
			</Box>
		</Box>
	);

	return (
		<Page headerProps={{ customToolbar: toolbar }}>
			<SEO
				title="Old School Bot"
				desc="Old School Bot is a discord bot based around Old School RuneScape. It has fun and useful commands, such as showing your account stats, and simulating loot."
			/>
			<Container maxWidth="lg">
				{
					<Box marginBottom={2}>
						<a
							target="_blank"
							rel="noopener noreferrer"
							style={{ textDecoration: 'none' }}
							href="https://wiki.oldschool.gg/"
						>
							<Alert variant="filled" severity="info">
								<AlertTitle>NEW: Click this to visit the new Wiki</AlertTitle>
								We have recently released a new Wiki which contains all the
								information about the bot. If you want information about the bot,
								please click here and use the Wiki!
							</Alert>
						</a>
						<br />
						<SimpleGrid gridItemProps={{ xs: 12, sm: 6, md: 3 }}>
							<ImageCard
								title="PvM"
								desc="You can now train combat skills! Just keep killing monsters like you normally do!"
								image={PVMImage}
							/>
							<ImageCard
								title="Player-owned houses"
								desc="Everyone now has their own, real, visual player-owned house!"
								image={POHImage}
							/>
							<ImageCard
								title="Bot School Old"
								desc={
									<>
										Check out "BSO", a copy of the bot which has fun changes,
										like custom items, bosses and pets:{' '}
										<CustomLink to="https://github.com/oldschoolgg/obdocs/blob/master/BSO.md">
											Check it out here
										</CustomLink>
									</>
								}
								image={MHImage}
							/>
							<ImageCard
								title="Support me on Patreon"
								desc={
									<>
										Please consider supporting me on Patreon, it doesn't cost
										much:{' '}
										<CustomLink to="https://www.patreon.com/oldschoolbot">
											https://www.patreon.com/oldschoolbot
										</CustomLink>
									</>
								}
								image={PatreonImage}
							/>
						</SimpleGrid>
					</Box>
				}
				<Switch>
					{tabs.map((tab) => (
						<Route exact key={tab.link} path={tab.link} component={tab.component} />
					))}
				</Switch>
			</Container>
		</Page>
	);
};
export default OldSchoolBotIndexPage;
